// extracted by mini-css-extract-plugin
export default {"card":"style_card__W5yOo","card_new":"style_card_new__ozDyI","icon":"style_icon__g8Hs2","cardBusiness":"style_cardBusiness__0XI5+"};